import React, { useEffect } from "react";

import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  Menu as MenuIcon,
} from "@mui/icons-material";
import { Box, IconButton, useMediaQuery, useTheme } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import useBooleanToggle from "@/hooks/useBooleanToggle";

import AppBar, { APP_BAR_HEIGHT } from "./AppBar";
import GlobalListeners from "./GlobalListeners";
import Sidebar from "./Sidebar";

const useStyles = makeStyles()({
  root: {
    display: "flex",
    height: "100vh",
  },
  content: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    marginTop: APP_BAR_HEIGHT,
    overflow: "auto",
  },
});

const AppLayout: React.FC = () => {
  const theme = useTheme();
  const { classes } = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [sidebarCollapsed, setSidebarCollapsed] = useBooleanToggle();
  const [mobileOpen, setMobileOpen] = useBooleanToggle();
  const location = useLocation();

  // Close the mobile drawer whenever the route changes (e.g. after tapping a
  // nav item) so the overlay doesn't linger over the new page.
  useEffect(() => {
    setMobileOpen.setFalse();
  }, [location.pathname]);

  const CollapseIcon =
    theme.direction === "rtl" ? ChevronRightIcon : ChevronLeftIcon;
  const ExpandIcon =
    theme.direction === "rtl" ? ChevronLeftIcon : ChevronRightIcon;

  return (
    <div className={classes.root}>
      <AppBar
        left={
          <Box>
            <IconButton
              onClick={
                isMobile ? setMobileOpen.toggle : setSidebarCollapsed.toggle
              }
              size="large"
              aria-label={isMobile ? "Open navigation menu" : "Toggle sidebar"}
            >
              {isMobile ? (
                <MenuIcon />
              ) : sidebarCollapsed ? (
                <ExpandIcon />
              ) : (
                <CollapseIcon />
              )}
            </IconButton>
          </Box>
        }
      />
      <Sidebar
        collapsed={sidebarCollapsed}
        isMobile={isMobile}
        mobileOpen={mobileOpen}
        onMobileClose={setMobileOpen.setFalse}
      />
      <GlobalListeners>
        <Box className={classes.content}>
          <Outlet />
        </Box>
      </GlobalListeners>
    </div>
  );
};

export default AppLayout;
